'use strict';

const Reflux = require('@muzzylane/reflux');
const Promise = require('bluebird');
const find = require('lodash/find');
const forEach = require('lodash/forEach');
const keys = require('lodash/keys');

const TemplateActions = require('../actions/TemplateActions');
const ServerRequest = require('../actions/request');
const SignInStore = require('./SignInStore');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const SignInActions = require('../actions/sign_in_actions');

let templates = [];
let globalTemplates = [];
let userID = null;
let initialized = false;
let action = {};
let error = null;
let last_new_template_id = null;

const TemplateStore = Reflux.createStore({
    listenables: [TemplateActions, SignInActions],
    init: function() {
        if (SignInStore.getState().initializedLocal){
            userID = SignInStore.getState().userInfo.id;
            this.getTemplates();
        }

        this.listenTo(SignInStore, this.onSignInChange);
    },

    resetState: function() {
        templates = [];
        userID = null;
        initialized = false;
        last_new_template_id = null;
        // action = {};
        // error = null;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    onSignInChange: function(signInStoreState) {
        if (signInStoreState.initializedLocal) {
            userID = signInStoreState.userInfo.id;
            this.getTemplates();

            if (signInStoreState.userInfo.admin) {
                const self = this;
                this.getGlobalTemplates()
                .then((gTemplates) => {
                    globalTemplates = gTemplates;
                    self.emitStatus();
                })
            }
        }
    },

    getState: function() {
        return {
            initialized: initialized,
            templates: templates,
            globalTemplates: globalTemplates,
            action: action,
            error: error
        }
    },

    getStateTemplate: function(moduleID) {
        return {
            initialized: initialized,
            template: find(templates, { "module_id": moduleID }),
            action: action,
            error: error
        }
    },

    getStateTemplateById: function(id) {
        return {
            initialized: initialized,
            template: templates.find(t => t.id === parseInt(id, 10)),
            action: action,
            error: error
        }
    },

    getStateTemplateByProduct: function(product) {
        return {
            initialized: initialized,
            template: this.getTemplateForProduct(product),
            action: action,
            error: error
        }
    },

    getTemplateForProduct: function(product) {
        return templates.find(t => t.product === product);
    },

    emitStatus: function() {
        //console.log("template store: EMIT");
        this.trigger(this.getState());
        action = {};
        error = null;
    },

    getTemplates: function() {
        const self = this;

        return this.getUserTemplates(userID)
            .then(function(res) {
                initialized = true;
                templates = res;
            })
            .catch(function(err) {
                console.error("getTemplates FAILURE:", err);
                initialized = true;

                switch(err.status){
                    case 403:
                        error = new ForgeError({message: ErrorConsts.FETCH_FAILED_TEMPLATES + ": " + ErrorConsts.FORBIDDEN});
                        break;
                    case 422:
                        error = new ForgeError({message: ErrorConsts.FETCH_FAILED_TEMPLATES + ": " + ErrorConsts.INVALID_INPUT});
                        break;
                    default:
                        error = new ForgeError({message: ErrorConsts.FETCH_FAILED_TEMPLATES + ": " + ErrorConsts.INTERNAL_GENERAL});
                }

                //TODO: setup retry?
            })
            .finally(function() {
                self.emitStatus();
            });
    },

    getUserTemplates: Promise.method(function(userID) {
        return ServerRequest.makeRequest(`/authoring/templates/user/${userID}`, 'GET')
                .then(function(res) {
                    var parsedUserTemps = res.slice(0);
                    parsedUserTemps = parsedUserTemps.sort(function(a, b) {
                        return a.name.localeCompare(b.name);
                    });

                    parsedUserTemps.forEach(function(tmpl) {
                        var createInfo;
                        try {
                            createInfo = JSON.parse(tmpl.create_info);
                        }
                        catch(err) {
                            createInfo = null;
                        }

                        tmpl.createInfo = createInfo;
                    });

                    return parsedUserTemps;
                });
    }),

    getGlobalTemplates: Promise.method(function() {
        return ServerRequest.makeRequest('/authoring/templates?q=all', 'GET')
            .then(function(res) {
                return res;
            });
    }),

    onCreateTemplateCompleted: function(actionID, res) {
        // console.log("onCreateTemplateCompleted:", actionID, res);
        const self = this;
        action.id = actionID;
        action.new_template_id = res.id;
        this.getGlobalTemplates()
        .then(function(templates) {
            globalTemplates = templates;
            self.emitStatus();
        })
    },

    onCreateTemplateFailed: function(actionID, err) {
        console.warn("onCreateTemplateFailed:", err);
    },

    onUpdateTemplateCompleted: function(actionID, res) {
        // console.log("onUpdateTemplateCompleted ", actionID, res);
        action.id = actionID;
        action.message = "Update successful."
        // update templates and globalTemplates with the new information
        if (res && res.id) {
            var t = find(templates,{id: res.id});
            if (t) {
                forEach(keys(t),function(k) {
                    if (k === 'createInfo') {
                        return;
                    }
                    else if (t[k] !== res[k]) {
                        t[k] = res[k];
                        if (k === 'create_info') {
                            // build the additional createInfo value from the stringified version
                            var createInfo;
                            try {
                                createInfo = JSON.parse(res.create_info);
                            }
                            catch(err) {
                                createInfo = null;
                            }
                            t.createInfo = createInfo;
                        }
                    }
                });
            }
            t = find(globalTemplates,{id: res.id});
            if (t) {
                forEach(keys(t),function(k) {
                    if (t[k] !== res[k]) {
                        t[k] = res[k];
                    }
                });
            }
        }
        // this.getTemplates();
        this.emitStatus();
    },

    onUpdateTemplateFailed: function(actionID, err) {
        console.warn("onUpdateTemplateFailed ", actionID, err);

        //todo: parse err.status if required
        action.id = actionID;
        action.error = err;
        this.emitStatus();
    },

    onDeleteTemplateCompleted: function(actionID, res) {
        //console.log("onDeleteTemplateCompleted ", actionID, res);
        this.getTemplates();
    },

    onDeleteTemplateFailed: function(actionID, err) {
        console.warn("onDeleteTemplateFailed ", actionID, err);
        action.id = actionID;
        action.error = err;
        this.emitStatus();
    }
});

module.exports = TemplateStore;
